import AutoVerificationResults from "@/components/probaworkflows_base_components/AutoVerificationResults/AutoVerificationResults.vue";
import NavigationBackButton from "@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue";
import AutoVerificationServices from '@/components/probaworkflows_base_components/AutoVerificationServices/AutoVerificationServices.vue';
import {
  get_user_role
} from '@/utils/constants/constants.js';
export default {
  name: "VerificationResultsPage",
  components: {
    AutoVerificationResults,
    AutoVerificationServices,
    NavigationBackButton
  },
  data: () => ({
    application_id: null,
    entity_profile_id: null,
    user_role: null,
  }),
   async created() {
    this.user_role = get_user_role();
  },
  mounted() {
    this.load_ids_from_session();
  },
  methods: {

    open_verification_modal() {
      this.$refs.verification_modal.open_modal();
    },
    load_ids_from_session() {
      // Get IDs from sessionStorage (adjust keys based on your app)
      this.application_id = sessionStorage.getItem("application_id") || 
                           sessionStorage.getItem("current_application_id");
      
      this.entity_profile_id = sessionStorage.getItem("entity_profile_id") || 
                              sessionStorage.getItem("current_entity_profile_id");

      // If not in session, try to get from route params
      if (!this.application_id && this.$route.params.application_id) {
        this.application_id = this.$route.params.application_id;
      }
      
      if (!this.entity_profile_id && this.$route.params.entity_profile_id) {
        this.entity_profile_id = this.$route.params.entity_profile_id;
      }
    }
  }
};